import { render } from "./medical.vue?vue&type=template&id=17929b20&scoped=true"
import script from "./medical.vue?vue&type=script&lang=js"
export * from "./medical.vue?vue&type=script&lang=js"

import "./medical.vue?vue&type=style&index=0&id=17929b20&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17929b20"]])

export default __exports__